// this is an autogenerated file from App/Auth/SignIn/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Auth_SignIn($id: String!, $captcha_token: String!, $browser_info: String!) {
  auth_leads(
    id: $id
    captcha_token: $captcha_token
    browser_info: $browser_info
  ) {
    status
    access_token: jwt_token
    access_token_expires_in: jwt_expires_in
  }
}

`